import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UtmifyScript } from './components/UtmifyScript';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { LookInside } from './components/LookInside';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-stone-50 text-stone-900 antialiased" data-id="element-0" data-mp="28sb9yzqi8x4j">
      <MetaPixel data-id="element-1" data-mp="23ujmchww7x65" />
      <UtmifyScript data-id="element-2" data-mp="23v2sz2h3ez4v" />
      <CountdownBar data-id="element-3" data-mp="23ti67z10skhk" />
      <main data-id="element-4" data-mp="3ikh8gaq64uzi">
        <Hero data-id="element-5" data-mp="3ikqy1x7ax04o" />
        <StatsBar data-id="element-6" data-mp="3ij64a9st9l7v" />
        <Difference data-id="element-7" data-mp="3ijpc2xoqyt86" />
        <Recognize data-id="element-8" data-mp="3ii4qvyobommz" />
        <WhatsInside data-id="element-9" data-mp="3mlat8v8bdto6" />
        <LookInside data-id="element-10" data-mp="3mkhmhu9cv461" />
        <InstantAccess data-id="element-11" data-mp="3mjzu58ptda3e" />
        <Bonuses data-id="element-12" data-mp="3mj6ipufwtwex" />
        <Offer data-id="element-13" data-mp="3rcj5s04xxv5k" />
        <Guarantee data-id="element-14" data-mp="3rbrcwx2qabiz" />
        <Testimonials data-id="element-15" data-mp="3rdkhm6ts6loc" />
        <Faq data-id="element-16" data-mp="3rd191gq0t9mz" />
      </main>
      <Footer data-id="element-17" data-mp="5yimri0b7dt" />
    </div>;
}